import Api from '@/services/Index'

const sendSms = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/start-application', data)
}

const verifySms = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/verify-application', data)
}

const login = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/login', data)
}


const updatePersonalInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/update-personal-information', data)
}

const updateEducationInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/update-education-information', data)
}

const getReferenceList = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/reference-list', data)
}


const addReference = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/add-reference', formData)
}


const deleteReference = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/delete-reference', data)
}


const downloadReferenceLetter = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/download-reference-letter', data, { responseType: 'arraybuffer' })
}

const addFile = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/add-file', formData)
}

const deleteFile = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/delete-file', data)
}

const downloadFile = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/download-file', data, { responseType: 'arraybuffer' })
}

const sendApprove = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/send-approve', data)
}
const passwordReminder = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/pin-reminder', data)
}
const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/bisep/applications', config)
}
const show = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/bisep/applications/'+id)
}

const update = async (data, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/bisep/applications/'+id, data)
}

const deleteApplication = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/bisep/applications/'+id)
}

const adminGetReferences = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/bisep/application/references', config)
}

const addAdminReference = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/references', data)
}

const updateAdminReference = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/application/references/'+id, data)
}

const deleteAdminReference = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/bisep/application/references/'+id)
}

const adminDownloadFile = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/applications/download-file', data, { responseType: 'arraybuffer' })
}

const approveDocument = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/applications/approve-document', data)
}

const approveApplicationForBisep = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/applications/approve-application-for-bisep', data)
}

const approveApplicationForFinance = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/bisep/applications/approve-application-for-finance', data)
}

const adminDownloadReferenceLetter = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/bisep/application/references/download-letter/'+id, { responseType: 'arraybuffer' })
}



export default {
    sendSms,
    verifySms,
    login,
    updatePersonalInfo,
    updateEducationInfo,
    getReferenceList,
    addReference,
    deleteReference,
    downloadReferenceLetter,
    addFile,
    deleteFile,
    downloadFile,
    sendApprove,
    passwordReminder,
    getAll,
    show,
    update,
    deleteApplication,
    adminGetReferences,
    addAdminReference,
    updateAdminReference,
    deleteAdminReference,
    adminDownloadFile,
    approveDocument,
    approveApplicationForBisep,
    approveApplicationForFinance,
    adminDownloadReferenceLetter
}
